import {
  PERMISSIONS,
  PERMISSIONS_GUILD,
  PERMISSIONS_HEALTH,
  PERMISSIONS_ZAERIN,
} from './permissions.constants';

export const ROLES = {
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_REPORT_VIEWER: 'ROLE_REPORT_VIEWER',
  ROLE_REPORT_VIEWER_HEALTH: 'ROLE_REPORT_VIEWER_HEALTH',
  ROLE_REPORT_VIEWER_HEALTH_SERVICEPORT: 'ROLE_REPORT_VIEWER_HEALTH_SERVICEPORT',
  ROLE_REPORT_VIEWER_HEALTH_VACCINATION: 'ROLE_REPORT_VIEWER_HEALTH_VACCINATION',
  ROLE_REPORT_VIEWER_HEALTH_VACCINATION_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_VACCINATION_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_VACCINATION_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_VACCINATION_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_TRANSPORT: 'ROLE_REPORT_VIEWER_HEALTH_TRANSPORT',
  ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_AUDIT: 'ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_AUDIT',
  ROLE_REPORT_VIEWER_HEALTH_GUILD: 'ROLE_REPORT_VIEWER_HEALTH_GUILD',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER: 'ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE: 'ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_GENERAL:
    'ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_PROVINCE:
    'ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_GUILD_AUDIT: 'ROLE_REPORT_VIEWER_HEALTH_GUILD_AUDIT',
  ROLE_REPORT_VIEWER_HEALTH_PASSENGER: 'ROLE_REPORT_VIEWER_HEALTH_PASSENGER',
  ROLE_REPORT_VIEWER_HEALTH_PASSENGER_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_PASSENGER_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_PASSENGER_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_PASSENGER_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_SCHOOL: 'ROLE_REPORT_VIEWER_HEALTH_SCHOOL',
  ROLE_REPORT_VIEWER_HEALTH_SCHOOL_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_SCHOOL_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_SCHOOL_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_SCHOOL_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT: 'ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT',
  ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_GENERAL: 'ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_GENERAL',
  ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_PROVINCE: 'ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_PROVINCE',
  ROLE_REPORT_VIEWER_HEALTH_REPORTS: 'ROLE_REPORT_VIEWER_HEALTH_REPORTS',
  ROLE_REPORT_VIEWER_GUILD: 'ROLE_REPORT_VIEWER_GUILD',
  ROLE_REPORT_VIEWER_GUILD_BAKERY: 'ROLE_REPORT_VIEWER_GUILD_BAKERY',
  ROLE_REPORT_VIEWER_GUILD_BAKERY_GENERAL: 'ROLE_REPORT_VIEWER_GUILD_BAKERY_GENERAL',
  ROLE_REPORT_VIEWER_INSPECTOR_USER_MANAGEMENT: 'ROLE_REPORT_VIEWER_INSPECTOR_USER_MANAGEMENT',
  ROLE_REPORT_VIEWER_GUILD_BAKERY_PROVINCE: 'ROLE_REPORT_VIEWER_GUILD_BAKERY_PROVINCE',
  ROLE_REPORT_VIEWER_GUILD_BAKERY_AUDIT: 'ROLE_REPORT_VIEWER_GUILD_BAKERY_AUDIT',
  ROLE_REPORT_VIEWER_ZAERIN: 'ROLE_REPORT_VIEWER_ZAERIN',
};

export const getRolePermissions = {
  [ROLES.ROLE_ADMIN]: Object.values(PERMISSIONS),
  [ROLES.ROLE_REPORT_VIEWER_HEALTH]: Object.values(PERMISSIONS_HEALTH),
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_SERVICEPORT]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SERVICEPORT_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SERVICEPORT_COUNTUPTIMER,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SERVICEPORT_LISTOFSERVICES,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SERVICEPORT_CALLCHART,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_VACCINATION]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_COUNT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_PERCENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_COUNT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_PERCENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_STATUS_CHART,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_VACCINATION_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_COUNT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_PERCENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_STATUS_CHART,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_VACCINATION_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_COUNT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_PERCENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_STATUS_CHART,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_TRANSPORT]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_PUBLIC_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_SAMAS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_VACCINE_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_PUBLIC_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_SAMAS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_VACCINE_PROCESS,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_PUBLIC_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_SAMAS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_VACCINE_PROCESS,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_PUBLIC_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_SAMAS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_VACCINE_PROCESS,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_TRANSPORT_AUDIT]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS_DOWNLOAD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILDS_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_NUMBER,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED_DOWNLOAD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILDS_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_NUMBER,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILDS_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_NUMBER,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_OWNER_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OF_GUILD_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_REGISTER_GUILD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_EMPLOYEE_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_PER_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_GUILD_AUDIT]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED_DOWNLOAD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_PASSENGER]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_BUS_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_LATEST_PASSENGERS_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_VACCINATE_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_VACCINATE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_BUS_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_AFFECTED_AFTER_TRAVELING_IN_COUNTRY_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGERS_VACCINE_PER_DOSES_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_VACCINATE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_PASSENGER_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_BUS_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_LATEST_PASSENGERS_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_VACCINATE_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_VACCINATE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_PASSENGER_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_BUS_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_AFFECTED_AFTER_TRAVELING_IN_COUNTRY_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGERS_VACCINE_PER_DOSES_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_VACCINATE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_SCHOOL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_CATEGORIES,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_DEPARTMENT_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_EDUCATIONAL_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_OF_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_STEUDENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TO_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_CATEGORIES,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_DEPARTMENT_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_EDUCATIONAL_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_OF_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_STEUDENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_SCHOOL_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_CATEGORIES,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_DEPARTMENT_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_EDUCATIONAL_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_OF_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_STEUDENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TO_VACCINATION_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_SCHOOL_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_CATEGORIES,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_DEPARTMENT_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_EDUCATIONAL_EMPLOYE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_OF_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_POSITIVE_PCR,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_STEUDENT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_VACCINATION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_PERCENTAGE_OF_GOVERNMENT_EMPLOYEES_IN_EACH_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_VACCINE_PER_PROVINCE,

    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_TEST_STATUS,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_GENERAL]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_PERCENTAGE_OF_GOVERNMENT_EMPLOYEES_IN_EACH_PROVINCE,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_TEST_STATUS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_VACCINE_PER_PROVINCE,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_RECRUITMENT_PROVINCE]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_MAP,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_CATEGORY,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_VACCINATION,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_PATIENTS,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_TEST_STATUS,
  ],
  [ROLES.ROLE_REPORT_VIEWER_HEALTH_REPORTS]: [
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_REPORTS_GUILD_REPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_REPORTS_GUILD_REPORT_DOWNLOAD,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_REPORTS_TRANSPORT_REPORT,
    PERMISSIONS_HEALTH.CAN_VIEW_HEALTH_REPORTS_TRANSPORT_REPORT_DOWNLOAD,
  ],
  [ROLES.ROLE_REPORT_VIEWER_GUILD]: Object.values(PERMISSIONS_GUILD),
  [ROLES.ROLE_REPORT_VIEWER_GUILD_BAKERY]: [
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_ACTIVE_TIME,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_AUDIT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_BAKERY_INSPECTION_NEED,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_DEAD_OWNER,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_INVALID_GUILD_CODE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_LICENCE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_PERMISSION,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_COST_AVERAGE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_RATE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SOLD_COUNT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SUPPLY_FLOUR,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_MAP,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_AUDIT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_BAKERY_INSPECTION_NEED,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_DEAD_OWNER,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_INVALID_GUILD_CODE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_LICENCE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_PERMISSION,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_AUDIT_OVERVIEW,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_INSPECTOR_USER_MANAGEMENT,

  ],
  [ROLES.ROLE_REPORT_VIEWER_GUILD_BAKERY_GENERAL]: [
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_ACTIVE_TIME,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_AUDIT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_BAKERY_INSPECTION_NEED,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_DEAD_OWNER,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_INVALID_GUILD_CODE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_LICENCE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_PERMISSION,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_COST_AVERAGE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_RATE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SOLD_COUNT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SUPPLY_FLOUR,
  ],
  [ROLES.ROLE_REPORT_VIEWER_GUILD_BAKERY_PROVINCE]: [
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_MAP,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_AUDIT,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_BAKERY_INSPECTION_NEED,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_DEAD_OWNER,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_INVALID_GUILD_CODE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_LICENCE,
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_PERMISSION,
  ],
  [ROLES.ROLE_REPORT_VIEWER_GUILD_BAKERY_AUDIT]: [
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_BAKERY_AUDIT_OVERVIEW,
  ],
  [ROLES.ROLE_REPORT_VIEWER_INSPECTOR_USER_MANAGEMENT]: [
    PERMISSIONS_GUILD.CAN_VIEW_GUILD_INSPECTOR_USER_MANAGEMENT,
  ],
  [ROLES.ROLE_REPORT_VIEWER_ZAERIN]: Object.values(PERMISSIONS_ZAERIN),
};
